import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

type Props = {
  subtitle?: string;
  to?: string;
  className?: string;
};

export function BrandMark({ subtitle = "", to = "/", className }: Props) {
  return (
    <Link
      to={to}
      className={cn(
        "group inline-flex items-center gap-2.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md",
        className
      )}
    >
      <img
        src="/logo.png"
        alt=""
        aria-hidden
        className="inline-block h-7 w-7 object-contain transition-transform group-hover:scale-110"
      />
      <span className="font-display text-lg font-bold tracking-tight">
        Editlock{" "}
        <span className="font-medium text-muted-foreground">{subtitle}</span>
      </span>
    </Link>
  );
}
